import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MathGamesSharedModule } from '@games/games-shared/math-games-shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import {
  DefaultImageModule,
  FitTextModule,
  FormFieldModule,
  TextsFilterComponent,
} from '@shared/components/games';
import { MathExpressionModule } from '../shared/components/math-expression/math-expression.module';
import { FractionsControllerComponent } from './fractions-controller/fractions-controller.component';
import { FractionsCorrectAnswerPreviewComponent } from './fractions-preview/fractions-answer-preview/fractions-answer-preview.component';
import { FractionsExamplePreviewComponent } from './fractions-preview/fractions-example-preview/fractions-example-preview.component';
import { FractionsParametersPreviewComponent } from './fractions-preview/fractions-parameters-preview/fractions-parameters-preview.component';
import { FractionsUserAnswerPreviewComponent } from './fractions-preview/fractions-user-answer-preview/fractions-user-answer-preview.component';
import { FractionsSettingsComponent } from './fractions-settings/fractions-settings.component';
import { CalculatorLayoutComponent } from '@shared/components/games/input-layouts/calculator-layout/calculator-layout.component';

@NgModule({
  declarations: [
    FractionsControllerComponent,
    FractionsSettingsComponent,
    FractionsCorrectAnswerPreviewComponent,
    FractionsExamplePreviewComponent,
    FractionsParametersPreviewComponent,
    FractionsUserAnswerPreviewComponent,
  ],
  exports: [
    FractionsControllerComponent,
    FractionsSettingsComponent,
    FractionsCorrectAnswerPreviewComponent,
    FractionsExamplePreviewComponent,
    FractionsParametersPreviewComponent,
    FractionsUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FitTextModule,
    NgSelectModule,
    DefaultImageModule,
    FormFieldModule,
    MathGamesSharedModule,
    MathExpressionModule,
    CalculatorLayoutComponent,
    TextsFilterComponent,
  ],
})
export class FractionsModule {}
